<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="1" class="form-group" style="min-width: 105px; max-width: 120px;">
        <label>Thao tác</label>
        <div class="dropdown btn-group" style="height: 36px;">
          <button class="btn">
            <div class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" v-model="actionData.model.selectedAll"
                  @change="changeSelectAll" id="selectedAll" />
                <label class="custom-control-label" for="selectedAll"></label>
              </div>
            </div>
          </button>
          <button type="button" class="dropdown-toggle dropdown-toggle-split btn" data-toggle="dropdown"
            aria-expanded="false" aria-haspopup="true"></button>
          <div class="dropdown-menu">
            <button :disabled="actionData.model.listSelectedId.length === 0" class="dropdown-item"
              @click="setupSelectOneAction('delete_list')" color="danger">
              <CIcon name="cil-trash" style="danger" class="mr-2" />
              Xóa tất cả
            </button>
          </div>
        </div>
      </CCol>
      <CCol sm="3" xs="12">
        <BaseInput :options="nameInput.options" :data="nameInput.data" :listener="nameInput.listener" />
      </CCol>
      <CCol sm="3" xs="12">
        <BaseInput :options="simInput.options" :data="simInput.data" />
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton style="float: right;margin-left: 5px;" color="primary" v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary" @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp;&nbsp;Tải lại
            </CButton>
            <CButton style="float: right;margin-left: 5px;" color="info" class="btn-action-primary"
              @click="$router.push('/sim-management/cards.html')">
              Tình trạng sim
            </CButton>
            <CButton style="float: right;" color="primary" v-c-tooltip.hover="'Tạo mới'" class="btn-action-primary"
              @click="$router.push('/sim-management/create.html')">
              <i class="fa fa-plus"></i>&nbsp;Tạo mới
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable :options="mainTable.options" :slots="mainTable.slots" :dataSource="mainTable.dataSource"
          @row-click="rowClickTable($event)" ref="mainTable">
          <template #checkbox="{ item }">
            <td class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" v-model="actionData.model.listSelectedId"
                  :value="item.id" :id="item.id" v-c-tooltip.hover="'Selected'" />
                <label class="custom-control-label" :for="item.id"></label>
              </div>
            </td>
          </template>
          <template #matchedSim="{ item }">
            <td>
              <span v-if="item.matchedSim">{{ item.matchedSim }}</span>
              <span v-else>-</span>
            </td>
          </template>
          <template #importDate="{ item }">
            <td>{{ $helper.formatDateDDMMYYYY(item.importDate) }}</td>
          </template>
          <template #createDate="{ item }">
            <td>{{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}</td>
          </template>
          <template #action="{ item }">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton color="info" variant="outline" v-c-tooltip.hover="'Cập nhật'" square size="sm"
                  @click="$router.push(`/sim-management/${item.id}/update.html`)">
                  <CIcon name="cil-pencil" />
                </CButton>
                <CButton color="success" variant="outline" square size="sm" v-c-tooltip.hover="'Tạo phiếu nhập'"
                  @click="$refs.quickImport.open(item)">
                  <i class="fa fa-sign-in"></i>
                </CButton>
                <CButton color="danger" variant="outline" square size="sm" v-c-tooltip.hover="'Xóa'"
                  @click="setupSelectOneAction('delete_one', item.id, item.name)">
                  <CIcon name="cil-trash" />
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping" ref="actionModal"></ModalConfirm>
    <SimQuickImport ref="quickImport"></SimQuickImport>
  </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import SimQuickImport from "./QuickImport";

export default {
  name: "SimLotList",
  components: {
    BaseTable,
    ModalConfirm,
    BaseInput,
    SimQuickImport
  },
  notifications: {
    showSuccessMsg: { type: "success", title: "Success" },
    showErrorMsg: { type: "error", title: "Error" },
    showWarningMsg: { type: "warn", title: "warn" }
  },
  data() {
    let that = this;
    let actionTypeMapping = new Map();

    actionTypeMapping.set("delete_one", {
      url: "/sim/delete",
      titlePopup: function () {
        return that.$helper.setupTitleAction("xóa", "lô sim", that.actionData.model.selectedName);
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return { id: that.actionData.model.selectedId };
      },
      successCallback: function () {
        that.actionData.model.listSelectedId = [];
        that.showSuccessMsg({ message: "Xóa lô sim " + that.actionData.model.selectedName + " thành công" });
        that.loadDataMainTable();
      }
    });

    actionTypeMapping.set("delete_list", {
      url: "/sim/delete-list",
      titlePopup: function () {
        return that.$helper.setupTitleAction("xóa", "các lô sim", "đã chọn");
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return { lsId: that.actionData.model.listSelectedId };
      },
      successCallback: function () {
        that.actionData.model.listSelectedId = [];
        that.showSuccessMsg({ message: "Xóa danh sách lô sim thành công" });
        that.loadDataMainTable();
      }
    });

    return {
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          selectedId: null,
          selectedName: null,
          listSelectedId: []
        }
      },
      nameInput: {
        options: {
          placeholder: "Tên lô / ghi chú / nhập từ",
          label: "Tên lô / ghi chú / nhập từ"
        },
        data: {
          name: "name",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      simInput: {
        options: {
          placeholder: "IMEI / SĐT / ICCID",
          label: "Tìm sim"
        },
        data: {
          name: "sim",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      mainTable: {
        options: {
          fields: [
            { key: "checkbox", label: "#", sorter: false, filter: false },
            { key: "name", label: "Tên lô sim" },
            { key: "source", label: "Nhập từ" },
            { key: "matchedSim", label: "Sim khớp (IMEI | SĐT | ICCID)" },
            { key: "note", label: "Ghi chú" },
            { key: "importDate", label: "Ngày nhập" },
            { key: "simCount", label: "Số sim" },
            { key: "createDate", label: "Ngày tạo" },
            { key: "action", label: "Thao tác", sorter: false, filter: false }
          ],
          slots: ["checkbox", "importDate", "createDate", "matchedSim", "action"],
          sorter: true,
          columnFilter: false,
          clickableRows: true,
          hover: false,
          itemsPerPageSelect: { label: " ", values: [15, 20, 30, 50, 100], external: true },
          pageSize: 20
        },
        dataSource: {
          url: "/sim/getPages",
          dataSubmit: function () {
            that.actionData.model.listSelectedId = [];
            return that.$helper.setupDataSubmit(that.$data);
          },
          response: function (dataResponse) {
            return dataResponse.data;
          }
        }
      }
    };
  },
  methods: {
    rowClickTable(value) {
      let targetClick = value.event.target;
      if (value.column === "action" && ($(targetClick).is("i.fa")) ||
        $(targetClick).is("button") || $(targetClick).is("svg") || $(targetClick).is("path")) {
        return;
      }
      if (value && value.item && value.item.id) {
        if (this.actionData.model.listSelectedId.includes(value.item.id)) {
          const index = this.actionData.model.listSelectedId.indexOf(value.item.id);
          if (index > -1) {
            this.actionData.model.listSelectedId.splice(index, 1);
            value.item._classes = "inactive";
          }
        } else {
          value.item._classes = "active";
          this.actionData.model.listSelectedId.push(value.item.id);
        }
      }
    },
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    changeSelectAll: function () {
      if (this.actionData.model.selectedAll) {
        this.actionData.model.listSelectedId = [];
        this.$refs.mainTable.items.forEach(each => {
          this.actionData.model.listSelectedId.push(each.id);
        });
      } else {
        this.actionData.model.listSelectedId = [];
      }
    },
    setupSelectOneAction: function (actionTypeKey, selectedId, selectedName) {
      let actionData = this.actionData.model;
      actionData.selectedName = selectedName || null;
      actionData.selectedId = selectedId || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    }
  },
  watch: {
    "actionData.model.listSelectedId": function (newValue) {
      let that = this;
      if (that.$refs.mainTable.items.length > 0 && newValue.length === that.$refs.mainTable.items.length) {
        that.actionData.model.selectedAll = true;
        that.$refs.mainTable.items.map(each => each._classes = "active");
      } else {
        that.actionData.model.selectedAll = false;
        if (newValue.length == 0) {
          that.$refs.mainTable.items.map(each => each._classes = "inactive");
        }
      }
    }
  }
};
</script>
